import styled from 'styled-components';

export const MaxWidthContainer = styled.div`
    max-width: ${({ theme }) => theme.breakpoints.md};
`;
